import { withStyles } from '@material-ui/styles';
import TableCell from '@material-ui/core/TableCell';

const TableCellHeader = withStyles(() => ({
  head: {
    color: 'white',
    background: '#4f81bc',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default TableCellHeader;
